import React from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  Typography,
  Tooltip,
  Box,
  Stack
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const DifficultySelector = ({ difficulty, onDifficultyChange }) => {
  const [localDifficulty, setLocalDifficulty] = React.useState(() => {
    return localStorage.getItem('difficulty') || 'normal';
  });

  React.useEffect(() => {
    if (difficulty !== localDifficulty) {
      onDifficultyChange({ target: { value: localDifficulty } });
    }
  }, []);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setLocalDifficulty(newValue);
    localStorage.setItem('difficulty', newValue);
    onDifficultyChange(event);
  };

  return (
    <Box>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
        <Typography variant="subtitle2" sx={{ color: '#666' }}>
          難易度
        </Typography>
        <Tooltip 
          title={
            <React.Fragment>
              <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>難易度說明</Typography>
              <Typography variant="body2" component="div">
                • Easy: 較為友善和直接的回應方式<br/>
                • Normal: 一般客戶的態度，適時提出疑慮<br/>
                • Hard: 較為謹慎和挑剔的態度，多提出質疑
              </Typography>
            </React.Fragment>
          } 
          arrow 
          placement="right"
        >
          <HelpOutlineIcon sx={{ color: '#666', fontSize: 16, cursor: 'help' }} />
        </Tooltip>
      </Stack>
      <FormControl size="small" fullWidth>
        <Select
          value={difficulty}
          onChange={handleChange}
          variant="outlined"
          sx={{
            bgcolor: '#f8f9fa',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'transparent'
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0, 0, 0, 0.1)'
            }
          }}
        >
          <MenuItem value="easy">簡單</MenuItem>
          <MenuItem value="normal">一般</MenuItem>
          <MenuItem value="hard">困難</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default DifficultySelector; 